import TagCloud from "TagCloud";
import { useEffect } from "react";

export default function Skills() {
  //set animation
  useEffect(() => {
    
      const container = ".tagcloud";
      const skills = [
        "JavaScript",
        "Python",
        "Java",
        "PHP",
        "Kotlin",
        "VB.NET",
        "SQL",
        "HTML/CSS",
        "Git",
        "Docker",
        "Google Cloud",
        "AWS",
        "Postman",
        "MySQL",
        "Oracle Database",
        "MongoDB",
        "Firebase",
      ];

      const options = {
        radius: window.innerWidth < 488 ? 120 : 200,
        maxSpeed: "normal",
        initSpeed: "normal",
        keep: "true",
      };

      TagCloud(container, skills, options);
      return () => {
        const element = document.querySelector(".tagcloud");
        if (element) element.innerHTML = ""
      };
  }, []);

  return (
    <div className="w-full md:items-center rounded-lg  grid grid-rows-2 "
     style={{
       background: 'linear-gradient(to bottom, #545454, #c4c2ba)',
       
       }}
    >
      <div className="md:px-4 pb-10 sm:pb-0 ">
        <div className="flex items-center  h-full justify-center ">
          <span className="tagcloud "></span>
        </div>
        <div className="w-[90%] h-[2px] rounded-full bg-[#2e2d69] m-auto"/>
      </div>
      <div className="text-white  py-3 px-3 md:px-10 gap-4 grid overflow-hidden">
        <div className="grid md:grid-cols-2 gap-4 text-white">
          {/**mostly used languages */}
          <div className="flex  bg-[#978b72] rounded-md p-3 gap-3">
            <div className="flex flex-col gap-2">
              <h1 className="text-xs text-white">Languages mostly used</h1>
              <div className="flex flex-wrap gap-2">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Kotlin
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  JavaScript
                </div>
              </div>
              <div className="flex flex-wrap gap-2 ">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Python
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Java
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Cloud
                </div>
              </div>
            </div>
          </div>

          {/*Framewoks */}
          <div className="flex flex-wrap items-center bg-[#978b72] rounded-md p-3  gap-3">
            <div className="flex flex-col gap-2">
              <h1 className="text-xs text-white">Frameworks</h1>
              <div className="flex gap-2">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  React
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Next.js
                </div>
              </div>
              <div className="flex gap-2 ">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Node.js
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Expres js
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Jetpack Compose
                </div>
              </div>
            </div>
          </div>
        </div>
        {/**second comlumn */}
        <div className="grid md:grid-cols-2 gap-4 text-white">
          {/**dev tools */}
          <div className="flex items-center bg-[#978b72] rounded-md p-3  gap-3">
            <div className="flex flex-col gap-2">
              <h1 className="text-xs text-white">Dev tools</h1>
              <div className="flex gap-2">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Git
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Docker
                </div>
              </div>
              <div className="flex gap-2 ">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Google cloud platform
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  AWS
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Postman
                </div>
              </div>
            </div>
          </div>
          {/**database */}
          <div className="flex items-center bg-[#978b72] rounded-md p-3  gap-3">
            <div className="flex flex-col gap-2">
              <h1 className="text-xs text-white">Database</h1>
              <div className="flex gap-2">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  MySQL
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Oracle database
                </div>
              </div>
              <div className="flex gap-2 ">
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  MongoDB
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  AWS databases
                </div>
                <div className="text-[10px] bg-[#cdc2b4] py-[1px] px-2 rounded-lg text-[#cc7707]">
                  Google cloud
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
